import { createApp } from 'vue';
import { default as orderService } from './order-service';
import { currency } from './../formatting/currency';

if ($('#cart').length) {

    let app = createApp({
        data() {
            return {
                cart: window.br.fullCart,
                isEditing: false
            };
        },
        methods: {
            currency,
            edit(line) {
                this.isEditing = true;
                line.editing = true;
            },
            refresh() {
                orderService.fullCart().then(data => {
                    this.cart.lines = orderService.prepLines(data.lines);
                    this.cart.overview = data.overview;
                    this.$refs.fieldset.disabled = false;
                    this.isEditing = false;
                });
            },
            update(line) {
                this.$refs.fieldset.disabled = true;
                orderService
                    .updateCart(line.sku, line.newQuantity)
                    .then(this.refresh);
            },
            remove(line) {
                this.$refs.fieldset.disabled = true;
                orderService
                    .remove(line.sku)
                    .then(this.refresh);
            }
        },
        mounted() {
        },
        computed: {
        }
    });

    app.mount('#cart');

}